export const HIDE_TRANSFER_COINS_MODAL = 'SHOW_TRANSFER_COINS_MODAL'
export const SHOW_TRANSFER_COINS_MODAL = 'HIDE_TRANSFER_COINS_MODAL'
export const SET_TRANSFER_COINS_MODAL_COINS = 'SET_TRANSFER_COINS_MODAL_COINS'
export const SET_TRANSFER_COINS_MODAL_COINS_TYPE = 'SET_TRANSFER_COINS_MODAL_COINS_TYPE'
export const SET_TRANSFER_COINS_MODAL_NAME = 'SET_TRANSFER_COINS_MODAL_NAME'
export const SET_TRANSFER_COINS_MODAL_ALIAS = 'SET_TRANSFER_COINS_MODAL_ALIAS'
